import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  ref: "label",
  class: "nr-tooltip__content"
}
const _hoisted_2 = {
  ref: "trigger",
  class: "nr-tooltip__trigger"
}
const _hoisted_3 = {
  ref: "trigger",
  class: "nr-tooltip__trigger"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tagName), { class: "nr-tooltip" }, {
    default: _withCtx(() => [
      (_ctx.$slots.label)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "label")
            ], 512),
            _createElementVNode("div", _hoisted_2, [
              _renderSlot(_ctx.$slots, "default")
            ], 512)
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            (_ctx.label)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("div", {
                    ref: "label",
                    class: "nr-tooltip__content"
                  }, _toDisplayString(_ctx.label), 513),
                  _createElementVNode("div", _hoisted_3, [
                    _renderSlot(_ctx.$slots, "default")
                  ], 512)
                ], 64))
              : _renderSlot(_ctx.$slots, "default", { key: 1 })
          ], 64))
    ]),
    _: 3
  }))
}